/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { PackageType } from "~/generated/graphql";
import { PACKAGE_UPDATE_STATUS_LABEL_OVERRIDES } from "./consts";
import { FilterType } from "./types";

export const getPackageUpdateStatusLabel = (key: string) =>
  PACKAGE_UPDATE_STATUS_LABEL_OVERRIDES[key] ?? key;

export function mapFilterTypeToPackageType(
  filterQuery: FilterType
): PackageType | null {
  switch (filterQuery) {
    case FilterType.INSTALLED:
      return PackageType.Installed;
    case FilterType.INSTALLED_PENDING_REBOOT:
      return PackageType.InstalledPendingReboot;
    case FilterType.UPDATED:
      return PackageType.Updated;
    case FilterType.AVAILABLE:
      return PackageType.Available;
    case FilterType.REMOVED:
      return PackageType.Removed;
    case FilterType.FAILED:
      return PackageType.Failed;
    default:
      return null;
  }
}
